// extracted by mini-css-extract-plugin
export default {"icon":"AccountIcon_icon__V1saB"};